<template>
    <div name="doctors" class="doctors">
        <span class="doctor-title">의사 선생님</span>
        <div class="bar-area" v-for="(doctor, index) in doctor_list" :key="`doctor_${index}`">
            <div class="bar" @click="selectDoctor(index)">
                <div class="thumbnail">
                    <img class="doctor-image" :src="doctor.file.url" />
                    <span class="doctor-name">{{ doctor.name }}</span>
                </div>               
                <img v-if="selectedIndex !== index" style="width: 22px;" src="../../assets/expand_more_icn.png" />
                <img v-else style="width: 22px;" src="../../assets/expand_less_icn.png" />          
            </div>
             <div class="doctor-description" v-if="selectedIndex === index">
                {{ doctor_list[selectedIndex].description}}
            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: 'doctors',
    data: function()
    {
        return {
            selectedIndex: -1,
        }
    },
    props: ['doctor_list'],
    methods: {
        selectDoctor: function(index)
        {
            if(this.selectedIndex === index)
            {
                this.selectedIndex = -1;
                return;
            }
            this.selectedIndex = index;
        }
    }
}
</script>

<style scoped>
    .doctors {
        width: 100%;
        display: flex;
        padding: 20px 16px;
        box-sizing: border-box;
        justify-content: flex-start;
        align-items: flex-start;
        border-radius: 6px;
        background: var(--gray-00, #FFF);
        box-shadow: 0 0 10px 0 rgba(0, 33, 56, 0.09);
        flex-direction: column;
    }
    .doctor-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .bar {
        width: 100%;
        height: 64px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        cursor: pointer;
    }
    .doctor-image {
        width: 64px;
        height: 64px;
        border-radius: 50%;
    }
    .doctor-name {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px; /* 128.571% */
        margin-left: 16px;
    }
    .thumbnail{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .doctor-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
    .doctor-description {
        width: 100%;
        padding: 16px;
        box-sizing: border-box;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        margin-top: 8px;
        white-space: pre-line;
    }
    .bar-area {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        margin-top: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/hospital/Doctors.vue